// Liste des comptes Telegram PARTAGÉE entre le menu (DashboardLayout) et les pages qui la demandent au même moment.
// #146 (16/09) : à l'ouverture de « Tracking links », /api/accounts partait 2 fois en parallèle (menu + page).
// Deux demandes simultanées = un seul appel ; une réponse de moins de 5 s est réutilisée telle quelle.
import api from './api';

let enVol = null;
let valeur = null;
let recuLe = 0;
const REUTILISABLE_MS = 5000;

export function chargerComptes({ frais = false } = {}) {
  if (!frais && valeur && Date.now() - recuLe < REUTILISABLE_MS) return Promise.resolve(valeur);
  if (enVol) return enVol;
  enVol = api.get('/accounts')
    .then(({ data }) => {
      valeur = Array.isArray(data) ? data : [];
      recuLe = Date.now();
      return valeur;
    })
    .finally(() => { enVol = null; });
  return enVol;
}
